import styled from 'styled-components';
import { Card } from 'semantic-ui-react';
import { breakpoints, colors, text, verticalGutter } from '../../styles';

export default styled(Card)`
  position: relative;
  height: 100%;
  text-align: left;
  font-size: ${text.small};
  overflow: hidden;

  .boxbutton {
    .ui.header {
      margin-top: 0;
      margin-bottom: ${verticalGutter / 4}rem;
    }

    h2.ui.header {
      font-weight: bold;
      font-style: italic;
      text-transform: uppercase;
      @media only screen and (min-width: ${breakpoints.computer}) {
        font-size: ${text.large};
      }
    }

    header + p {
      margin-top: ${verticalGutter * 0.75}rem;
    }

    > * {
      position: relative;
      z-index: 1;
    }

    &__inner {
      padding: ${verticalGutter}rem ${verticalGutter / 2}rem;
      display: flex;
      height: 100%;

      @media only screen and (min-width: ${breakpoints.tablet}) {
        padding: ${verticalGutter}rem;
      }

      .icon {
        width: ${(1 / 5) * 100}%;
        white-space: nowrap;
        margin: 0;
        text-align: right;
        svg {
          vertical-align: top;
          margin: 0 2px;

          path,
          polygon {
            fill: ${colors.primary};
          }
        }
      }
    }

    &__content {
      width: ${(4 / 5) * 100}%;
      padding-left: ${verticalGutter / 2}rem;
    }

    &__cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      text-indent: -300vw;
      .boxbutton--nocover & {
        z-index: -1;
      }
    }

    &--primary {
      &,
      &.ui.card {
        background: ${colors.primary};
        transition: background 0.3s ease-in-out;
        &:hover {
          background: ${colors.darkGreen};
        }
      }
      &,
      .ui.header {
        color: #fff;
      }

      .boxbutton__inner {
        .icon svg {
          path,
          polygon {
            fill: ${colors.greyBackground};
          }
        }
      }
    }

    &--secondary {
      &:hover {
        .boxbutton {
          &__inner {
            &:before {
              opacity: 0.6;
            }
          }
        }
      }

      .boxbutton {
        &__inner {
          padding: ${verticalGutter * 0.75}rem;
          &:before {
            content: '';
            width: 200%;
            height: 400%;
            background: ${colors.primary};
            opacity: 0.8;
            position: absolute;
            bottom: 0;
            right: 50%;
            transform: rotate(-20deg);
            transform-origin: right bottom;
            z-index: 1;
            transition: opacity 0.3s ease-in-out;
          }

          &:after {
            z-index: 0;
          }

          .icon {
            width: calc(${(1 / 2) * 100}% + ${verticalGutter}rem);
            height: calc(100% + ${verticalGutter} * 2}rem);
            text-align: left;
            position: relative;
            background: transparent;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: left center;
            margin: ${verticalGutter * -1}rem ${verticalGutter / -2}rem;
            margin-right: 0;
            padding: ${verticalGutter}rem;
            svg {
              position: relative;
              z-index: 1;
              path,
              polygon {
                fill: ${colors.greyBackground};
              }
            }
          }
        }

        &__content {
          width: ${(1 / 2) * 100}%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        @media only screen and (min-width: ${breakpoints.tablet}) {
          &__inner {
            .icon {
              margin-left: ${verticalGutter * -1}rem;
            }
          }
        }

        @media only screen and (min-width: ${breakpoints.largeMonitor}) {
          &__inner {
            &:before {
              transform: rotate(-30deg);
            }
          }
        }

        @media only screen and (min-width: ${breakpoints.widescreenMonitor}) {
          &__inner {
            &:before {
              right: 65%;
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/BoxButton/BoxButton.style.js